export default "__VITE_ASSET__EupVxzZi__"